import React from 'react'
import BackLink from 'components/Shared/BackLink/BackLink'
import DocumentUploader from 'components/Shared/DocumentUploader/DocumentUploader'
import styles from './UploaderPage.module.scss'
import { uploadDocument } from 'utils/Client/apiRequest'
import PropTypes from 'prop-types'

const UploaderPage = (props) => {
  const { addDocument } = props

  const uploadAndAddDocument = async (file) => {
    const document = await uploadDocument(file)

    addDocument(document.data)
  }

  const myUploadedDocumentsPath = '/documents/my-uploads'

  return (
    <div className={styles.UploaderPage}>
      <div className={styles.backLink}>
        <BackLink text="Shared" path={myUploadedDocumentsPath} />
      </div>
      <DocumentUploader
        className={styles.documentUploader}
        doneLink={myUploadedDocumentsPath}
        uploadFile={uploadAndAddDocument} />
    </div>
  )
}

UploaderPage.propTypes = {
  addDocument: PropTypes.func.isRequired
}

export default UploaderPage



// WEBPACK FOOTER //
// ./src/components/Client/UploaderPage/UploaderPage.jsx